var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _vm.open
      ? _c(
          "div",
          {
            staticClass: "modal-component",
            class: { small: _vm.size === "small", large: _vm.size === "large" }
          },
          [
            _c("div", {
              staticClass: "overlay",
              attrs: { "aria-label": "Close Modal" },
              on: { click: _vm.handleOverlayClose }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "modal" }, [
              _c(
                "div",
                { staticClass: "close-button" },
                [
                  _vm._t("close-button", [
                    _c("fx-button", {
                      attrs: {
                        kind: "icon",
                        variant: "frameless",
                        size: "large",
                        icon: "close",
                        "aria-label": "Close modal"
                      },
                      on: { click: _vm.close }
                    })
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c("header", { staticClass: "heading" }, [
                    _vm.heading
                      ? _c("h2", [_vm._v(_vm._s(_vm.heading))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._t("default")
                ],
                2
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }